// ChatResponsiveDesignLayout.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useParams, useLocation } from 'react-router';
import UniversalComponent from '../component/UniversalComponent.jsx';
import { DESKTOP_TOP_MARGIN_OFFSET } from '../resource/chatroomConstants.js';
import { matchPath } from 'react-router';
import { color } from '../style/variables.js';

const ChatResponsiveDesignLayout = ({
  deviceHeight = 0,
  isOnDesktop = false,
  children,
}) => {
  const { chatroomId } = useParams();
  const { pathname } = useLocation();
  const isOnChatMessageDetail = matchPath(
    '/chat/:chatroomId/message/:messageId',
    pathname
  );

  return isOnDesktop && !isOnChatMessageDetail ? (
    <ChatListWrapper>
      <ChatroomsWrapper>
        <UniversalComponent
          filename="Container_Chatrooms"
          activeId={chatroomId}
          importer={
            /* #__LOADABLE__ */ () => import('../container/Chatrooms.js')
          }
        />
      </ChatroomsWrapper>

      <OutletWrapper
        deviceHeight={deviceHeight}
        isOnDefaultPage={pathname === '/chat'}
      >
        {children}
      </OutletWrapper>
    </ChatListWrapper>
  ) : (
    children
  );
};

ChatResponsiveDesignLayout.propTypes = {
  deviceHeight: PropTypes.number,
  isOnDesktop: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

const ChatListWrapper = styled.div`
  margin-top: calc(
    var(--space-to-pinned-notification) + ${DESKTOP_TOP_MARGIN_OFFSET}px
  );
  display: flex;
`;

const ChatroomsWrapper = styled.div`
  min-width: 360px;
  width: 360px;
`;

const OutletWrapper = styled.main`
  height: ${({ deviceHeight }) =>
    `calc(${`${deviceHeight}px` || '100vh'} - ${DESKTOP_TOP_MARGIN_OFFSET}px - var(--space-to-pinned-notification))`};
  overflow-x: auto;
  padding-top: ${({ isOnDefaultPage }) => (isOnDefaultPage ? '40px' : '0')};
  flex-grow: 1;
  border-left: 1px solid ${color.neutral['30_alpha_15']};
`;

export default ChatResponsiveDesignLayout;
